module.exports = __webpack_public_path__ + "img/vat_needed-false.b89da25f.png";